import { GET_FREE_TRIAL_STATUS, SET_FREE_TRIAL_STATUS } from './constants'

export const getFreeTrialStatus = () => ({
  type: GET_FREE_TRIAL_STATUS.INITIATE,
})
export const getFreeTrialStatusSuccess = (isValid) => ({
  type: GET_FREE_TRIAL_STATUS.SUCCESS,
  isValid,
})
export const getFreeTrialStatusError = (error) => ({
  type: GET_FREE_TRIAL_STATUS.ERROR,
  error,
})

export const setFreeTrialStatus = (value) => ({
  type: SET_FREE_TRIAL_STATUS.INITIATE,
  payload: { value },
})
export const setFreeTrialStatusSuccess = (status, message) => ({
  type: SET_FREE_TRIAL_STATUS.SUCCESS,
  status,
  message,
})
export const setFreeTrialStatusError = (error) => ({
  type: SET_FREE_TRIAL_STATUS.ERROR,
  error,
})

export default {
  getFreeTrialStatus,
  setFreeTrialStatus,
}
